/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1BannerClassStudentsQueryResponse,
  GetApiV1BannerClassStudentsQueryParams,
  GetApiV1BannerClassStudents401,
  GetApiV1BannerClassStudents500,
} from "../../types/bannerRegistroController/GetApiV1BannerClassStudents.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1BannerClassStudents } from "../../clients/bannerRegistroController/getApiV1BannerClassStudents.ts";

export const getApiV1BannerClassStudentsQueryKey = (
  params?: GetApiV1BannerClassStudentsQueryParams,
) =>
  [
    { url: "/api/v1/banner/class-students" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1BannerClassStudentsQueryKey = ReturnType<
  typeof getApiV1BannerClassStudentsQueryKey
>;

export function getApiV1BannerClassStudentsQueryOptions(
  params?: GetApiV1BannerClassStudentsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1BannerClassStudentsQueryKey(params);
  return queryOptions<
    GetApiV1BannerClassStudentsQueryResponse,
    ResponseErrorConfig<
      GetApiV1BannerClassStudents401 | GetApiV1BannerClassStudents500
    >,
    GetApiV1BannerClassStudentsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1BannerClassStudents(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna turmas paginadas (20 por página) filtradas por texto (descrição ou código) e opcionalmente por marca(s). Informe `brandIds` uma ou mais vezes para filtrar por múltiplas marcas (ex: `?brandIds=1&brandIds=2`). Use `activeOnly=true` para restringir apenas às turmas ativas e vigentes (data início ≤ hoje ≤ data fim). **(Requer Authorization para autenticação)**
 * @summary Listar turmas para seleção no banner (Requer Authorization para autenticação)
 * {@link /api/v1/banner/class-students}
 */
export function useGetApiV1BannerClassStudents<
  TData = GetApiV1BannerClassStudentsQueryResponse,
  TQueryData = GetApiV1BannerClassStudentsQueryResponse,
  TQueryKey extends QueryKey = GetApiV1BannerClassStudentsQueryKey,
>(
  params?: GetApiV1BannerClassStudentsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1BannerClassStudentsQueryResponse,
        ResponseErrorConfig<
          GetApiV1BannerClassStudents401 | GetApiV1BannerClassStudents500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1BannerClassStudentsQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1BannerClassStudentsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1BannerClassStudents401 | GetApiV1BannerClassStudents500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
